var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M20.156 16.5702C20.067 16.463 19.9797 16.3559 19.894 16.2525C18.7154 14.827 18.0024 13.9666 18.0024 9.93107C18.0024 7.84179 17.5026 6.1275 16.5174 4.84179C15.791 3.89196 14.809 3.17143 13.5147 2.63893C13.498 2.62966 13.4832 2.61751 13.4708 2.60304C13.0052 1.04411 11.7313 0 10.2945 0C8.85774 0 7.58434 1.04411 7.11881 2.60143C7.10638 2.61537 7.09172 2.62714 7.07542 2.63625C4.05506 3.87964 2.5872 6.26518 2.5872 9.92946C2.5872 13.9666 1.87524 14.827 0.695595 16.2509C0.60988 16.3543 0.522559 16.4593 0.43363 16.5686C0.203917 16.8456 0.058374 17.1826 0.014227 17.5398C-0.0299199 17.897 0.0291767 18.2593 0.184523 18.5839C0.515059 19.2804 1.21952 19.7127 2.02363 19.7127H18.5713C19.3717 19.7127 20.0713 19.2809 20.4029 18.5877C20.5589 18.263 20.6186 17.9003 20.5748 17.5428C20.531 17.1852 20.3857 16.8477 20.156 16.5702ZM10.2945 24C11.0686 23.9994 11.8282 23.7892 12.4925 23.3919C13.1569 22.9945 13.7013 22.4248 14.0681 21.743C14.0854 21.7104 14.0939 21.6738 14.0929 21.6368C14.0918 21.5999 14.0813 21.5638 14.0622 21.5322C14.0431 21.5005 14.0161 21.4744 13.9839 21.4562C13.9517 21.4381 13.9154 21.4285 13.8785 21.4286H6.71167C6.67466 21.4284 6.63825 21.4379 6.60599 21.456C6.57372 21.4741 6.5467 21.5003 6.52755 21.532C6.5084 21.5636 6.49778 21.5997 6.49672 21.6367C6.49565 21.6737 6.50419 21.7103 6.52149 21.743C6.8882 22.4247 7.43255 22.9944 8.09681 23.3917C8.76108 23.7891 9.52049 23.9993 10.2945 24Z",
    fill: "#092C4C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.6002,
    cy: 6.4,
    r: 5.65,
    fill: "#FF1B1B",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.7bff118cbfc97999a02da61c4925a0c6.svg";
export { ForwardRef as ReactComponent };